<template>
  <div class="kye-report-dgkp006" @click="handleClick('cardClick')">
    <div class="dgkp006_main-cell-title">
      <img
        class="dgkp006_main-icon1"
        :src="data.mainIcon1 || mainIcon1"
        @click="handleClick('mainIcon1')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainIcon1', data.mainIcon1]}"
      />
      <div
        class="dgkp006_main-title"
        @click="handleClick('mainTitle')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', data.mainTitle]}"
      >{{ data.mainTitle }}</div>
      <KyeReportCardQuestion
          class="dgkp006_main-icon2"
          :icon="data.mainIcon2"
          :popover="data.popover"
          @click="handleClick('mainIcon2')">
          <slot :name="'tooltip'"></slot>
      </KyeReportCardQuestion>
      <slot name="cell-title-right"></slot>
    </div>
    <div class="dgkp006_main-cell-index">
      <div
        class="dgkp006_list-cell"
        :class="[`dgkp006_list-cell-${index}`]"
        v-for="(item, index) in data.list"
        :key="index">
        <div
          class="dgkp006_list-title"
          @click="handleClick('listTitle', index)"
          v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, item.listTitle]}"
        >{{ item.listTitle }}</div>
        <div class="dgkp006_list-cell-index">
          <div
            class="dgkp006_list-index1"
            @click="handleClick('listIndex', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, item.listIndex]}"
          >
            {{ item.listIndex }}
          </div>
          <div class="dgkp006_list-rate-cell" :class="getIndexColor(item.listIcon)" v-if="item.listRate">
            <div
              class="dgkp006_list-rate"
              @click="handleClick('listRate', index)"
              v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, item.listRate]}"
            >{{ item.listRate }}</div>
            <kyeReportCardArrow
              @click="handleClick('listIcon', index)"
              class="dgkp006_list-icon"
              :type="item.listIcon"
              v-events="{ eventsMap, ignoreEventName, args: ['listIcon', index, item.listIcon]}"
            ></kyeReportCardArrow>
          </div>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/dgkp004.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportDgkp006',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    }
  }
}
</script>
<style lang="scss">
.kye-report-dgkp006 {
  @import '../../style/extend.scss';
  background: #FFFFFF;
  border-radius: 4px;
  padding: 16px;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  display: flex;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 3px;
    border-radius: 4px 0 0 4px;
    opacity: 0.5;
    background: linear-gradient(180deg, #AFA8FF 0%, #7B74FF 100%);
    content: '';
  }
  .dgkp006_main-cell-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #666666;
    font-size: 12px;
    gap: 4px;
    .dgkp006_main-icon1 {
      width: 12px;
      height: 12px;
    }
  }
  .dgkp006_main-cell-index {
    display: flex;
    flex-direction: row;
    margin-top: 12px;
    gap: 8px;
    .dgkp006_list-cell {
      display: flex;
      flex-direction: column;
      flex: 1;
      position: relative;
      padding-left: 12px;
      &:not(:first-child) {
        &::before {
          position: absolute;
            content: '';
            top: 0;
            left: 0;
            bottom: 0;
            width: 0.5px;
            background:  #EBEDF5;
        }
      }
      .dgkp006_list-title {
        font-size: 12px;
        color: #666666;
      }
      .dgkp006_list-cell-index {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        .dgkp006_list-index1 {
          color: var(--g-color-primary);
          font-size: 18px;
          font-weight: 600;
          line-height: 22px;
        }
        .dgkp006_list-rate-cell {
          display: flex;
          flex-direction: row;
          font-size: 12px;
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/dgkp006/index.vue